module.exports = __webpack_public_path__ + "static/media/recovery_seed.bf679a92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skywallet/images/recovery_seed.svg
// module id = 1618
// module chunks = 0